import { Injectable } from '@angular/core';
import { CrudHttpService } from 'collection';
import { environment } from '../../../environments/environment';

enum TrackEvent {
  CHAT_SEND = 'chat_sent',
  PROJECT_FILES_UPLOAD = 'documentation_upload',
  LOGIN = 'login_web'
}

@Injectable({ providedIn: 'root' })
export class PQLEventService {
  track(eventName: string): void {
    const eventParamToSend = { key: TrackEvent[eventName] };
    this._http.post({ url: environment.apiUrl + '/v1/pql-events/track', data: eventParamToSend }).subscribe();
  }

  constructor(private _http: CrudHttpService) {}
}
